import { service } from 'services';
import { basicCRUDAction, hotGetAction } from 'utils';
import { ACTIONS_TYPES } from '../helper';

export const targetGroup = {
  getAll: async () => hotGetAction({
    action: ACTIONS_TYPES.TARGET_GROUP.GET_ALL,
    apiResult: service.targetGroup.getAll(),
    isRetrieveItems: true,
  }),

  get: async ({ id }) => hotGetAction({
    action: ACTIONS_TYPES.TARGET_GROUP.GET,
    apiResult: service.targetGroup.get({ id }),
  }),

  create: async ({ properties }) => basicCRUDAction({
    action: ACTIONS_TYPES.TARGET_GROUP.CREATE,
    apiResult: service.targetGroup.create({ properties }),
  }),

  update: async ({ id, properties }) => basicCRUDAction({
    action: ACTIONS_TYPES.TARGET_GROUP.UPDATE,
    apiResult: service.targetGroup.update({ id, properties }),
  }),

  updateParial: async ({ id, properties }) => basicCRUDAction({
    action: ACTIONS_TYPES.TARGET_GROUP.UPDATE_PARTIAL,
    apiResult: service.targetGroup.updatePartial({ id, properties }),
  }),

  delete: async ({ id }) => basicCRUDAction({
    action: ACTIONS_TYPES.TARGET_GROUP.DELETE,
    apiResult: service.targetGroup.delete({ id }),
  }),
};
